<template>
  <v-dialog 
    v-model="dialog" 
    class="ch-dialog" 
    max-width="800"
  >
    <div class="ch-dialog-card">
      <v-toolbar class="ch-dialog-toolbar" :height="45">
        <v-toolbar-title>
          <i class="fas fa-briefcase fa-fw"></i>
          <span class="title">NEW USER</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <button @click="closeDialog" class="close-btn">
          <i class="fas fa-window-close fa-fw"></i>
        </button>
      </v-toolbar>
      <div class="ch-dialog-body">
        <v-form v-model="valid" ref="form">
          <v-layout row wrap>
            <v-flex xs6 class="pl-3 pr-3">
              <div class="form-group">
                <div class="form-title">NAME *</div>
                <div class="form-input">
                  <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    full-width
                  ></v-text-field>
                </div>
              </div>
              <div class="form-group">
                <div class="form-title">EMAIL *</div>
                <div class="form-input">
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    full-width
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pl-3 pr-3">
              <div class="form-group">
                <div class="form-title">PASSWORD *</div>
                <div class="form-input">
                  <v-text-field
                    class="ch-input-pwd"
                    v-model="password"
                    :rules="passwordRules"
                    full-width
                  ></v-text-field>
                </div>
              </div>
              <div class="form-group">
                <div class="form-title">TAG</div>
                <div class="form-input">
                  <v-text-field
                    v-model="tag"
                    full-width
                  ></v-text-field>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-form>
      </div>
      <div class="ch-dialog-footer">
        <button
          :class="{ save: valid }"
          :disabled="!valid"
          @click="createDomain"
        >
          <i class="fas fa-save fa-fw"></i>
          <span>SAVE</span>
        </button>
        <button
          class="cancel"
          @click="closeDialog"
        >
          <i class="fas fa-times-circle fa-fw"></i>
          <span>CANCEL</span>
        </button>
        <!-- <v-btn
          color="error"
          @click.native="clearAllField"
        >
          <v-icon class="mr-2">clear_all</v-icon>
          Clear All
        </v-btn> -->
      </div>
    </div>
  </v-dialog>
</template>

<script>
  import { usersEventBus } from '@/components/admin/users/usersEventBus';
  import api from '../../../api';

  export default {
    data() {
      return {
        dialog: false,
        valid: true,
        id: null,
        email: null,
        name: null,
        password: null,
        tag: '',
        nameRules: [
          v => (v === 0) || !!v || 'Please input Name',
        ],
        emailRules: [
          v => (v === 0) || !!v || 'Please input Email',
          /* eslint max-len: ["error", { "code": 200 }] */
          v => /^\w+([\\.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid',
        ],
        passwordRules: [
          v => (v === 0) || !!v || 'Please input Password',
        ],
      };
    },
    methods: {
      createDomain() {
        const params = {
          email: this.email,
          password: this.password,
          name: this.name,
          tag: this.tag,
          device: this.device,
          os: this.os,
          push: this.push,
        };
        api.createUser(params)
        .then((result) => {
          if (result.status === 200) {
            this.alert.type = 'check_circle';
            this.alert.color = 'green';
            this.alert.message = 'Success Save';
            this.alertOccur();
            usersEventBus.$emit('reloadList');
            this.closeDialog();
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
          this.createDialog = false;
        });
      },
      clearAllField() {
        this.$refs.form.reset();
      },
      /**
       * @description 전체 창 open, close
       */
      openDialog() {
        this.dialog = true;
      },
      closeDialog() {
        this.dialog = false;
        this.clearAllField();
      },
    },
    mounted() {
      usersEventBus.$on('openDialog', () => {
        console.info('openDialog');
        this.openDialog();
      });
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/users/CreateUser.vue